import React from "react"
import { injectIntl } from "react-intl"
import GlobalHelper from "../GlobalHelper"

type OwnProps = {
    email: string
    handleFormChange: () => void
    placeholder: string
    name: string
    id: string
    type: string
    className: string
    required: boolean
}

const EmailInputComponent = (props: OwnProps) => {
    return (
        <>
            <input
                name={props.name}
                value={props.email}
                onChange={props.handleFormChange}
                pattern={GlobalHelper.getEmailValidationRegexString()}
                id={props.id}
                type={props.type}
                className={props.className}
                placeholder={props.placeholder}
                required={props.required}
            />

        </>
    )

}

export default injectIntl(EmailInputComponent)






// WEBPACK FOOTER //
// ./src/common/inputs/EmailInputComponent.tsx